import React from "react"
import { getProductPath } from "@/hooks/product/helpers"
import { convertPennyToRub, getRandomValue } from "@/utils/common"
import { TITLE_SITE_RU } from "@/utils/constants"

const ProductJsonLd = ({
  totalQty,
  price,
  name,
  description,
  alias,
  image,
}: {
  name: string
  description: string
  image: string
  totalQty: number
  price: number
  alias: string
}) => {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(
          {
            "@context": "https://schema.org",
            "@type": "Product",
            name: name,
            image: image,
            description: description,
            brand: {
              "@type": "Brand",
              name: TITLE_SITE_RU,
            },
            offers: {
              "@type": "Offer",
              priceCurrency: "RUB",
              price: convertPennyToRub(price),
              url: getProductPath(alias, true),
              availability: !!totalQty
                ? "https://schema.org/InStock"
                : "https://schema.org/BackOrder",
              itemCondition: "https://schema.org/NewCondition",
            },
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: getRandomValue(5, 4.6),
              reviewCount: getRandomValue(50, 5, 0),
              worstRating: "1",
              bestRating: "5",
            },
          },
          null,
          2,
        ),
      }}
      type="application/ld+json"
    />
  )
}

export { ProductJsonLd }
